import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, onMounted } from "../../../adapter-vue";
import Icon from "../../common/Icon.vue";
import Server, { IMenuItem } from "./server";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose }) {

const showChildren = ref<Array<IMenuItem>>([]);
const convHeaderRef = ref(undefined);

const menuList = computed(() => {
  return Server.getInstance().getMenu();
})

onMounted(() => {
  showChildren.value = [];
});

const handleMenu = (item: IMenuItem) => {
  const { data: { children }, listener = { onClicked: () => {} } } = item;
  if (children) {
    showChildren.value = showChildren.value.length > 0 ? [] : children;
  } else {
    listener.onClicked(item);
    closeChildren();
  }
}

const closeChildren = () => {
  showChildren.value = [];
}

expose({
  closeChildren
})


return { __sfc: true,showChildren, convHeaderRef, menuList, handleMenu, closeChildren, Icon }
}

})